import { render, staticRenderFns } from "./SupplierCertificationsTab.vue?vue&type=template&id=409864a2&scoped=true&"
import script from "./SupplierCertificationsTab.vue?vue&type=script&lang=js&"
export * from "./SupplierCertificationsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "409864a2",
  null
  
)

export default component.exports